(function () {
  "use strict";

    window.onload = function () {
        var ui = new UI();
        setTimeout(() => {
            ui.init(); 
        }, 200);
      };
  
    function UI() {
      var _this = this;
      this.init = function () {
        console.log("init");
        _this.events(); 
        if ($(".rellax").length > 0) {
          _this.initRellax(); 
        }
        if ($(".testimonials").length) {
          _this.triggerAnimations();
        }
        if ($(".cs-tabs__list").length) { 
          new SimpleBar($(".cs-tabs-wrap")[0]);   
        } 
        if ($(".testimonials").length) {
          var swiper = new Swiper(".testimonials-wrapper", {
            speed: 400,
            loop: false, 
            slidesPerView: 1.1,
            spaceBetween: 10,
            centeredSlides: true,
            initialSlide: 1,
            pagination: {
              el: '.testimonials-wrapper .swiper-pagination',
              type: 'bullets',
            },
            breakpoints: {
              375: {
                slidesPerView: 1.3,
              },
              767: {
                slidesPerView: 2.2,
              },
              1024: {
                slidesPerView: 3.2,
                centeredSlides: false,
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 25,
                pagination: false,
                centeredSlides: false,
              },
              1600: {
                slidesPerView: 6, 
                spaceBetween: 20,
                centeredSlides: true,
                pagination: false,
              },
            }
          });
        }
      };
      this.typeWriter = function () {
        var app = document.getElementById("typedWords");
        var words = document.querySelector(".hero__title").getAttribute("words");
        var wordsArray = words.split(",");
        var typewriter = new Typewriter(app, {
          loop: true,
          delay: 75,
          pauseFor: 1700,
          strings: wordsArray,
          autoStart: true
        });
      };
      this.initParallax = function () {
        /* parallax scene init */
        if ($("#dogScene").length) {
          var scene = $("#dogScene").get(0);
          var parallaxInstance = new Parallax(scene, {
            limitY: "0",
            invertX: false
          });
        }
        if ($("#dogScene2").length) {
          var scene = $("#dogScene2").get(0);
          var parallaxInstance = new Parallax(scene, {
            limitY: "0",
            invertX: false
          });
        }
      };
      this.initRellax = function () {
        var md = new MobileDetect(window.navigator.userAgent);
        if (!md.mobile()) {
          var rellax = new Rellax(".rellax");
        }
      };
      this.triggerAnimations = function () {
        /* hero animations */
        
        var heroTableIntro = document.querySelector(".table_intro");
        var heroToggleContainer= document.querySelectorAll(".toggle-container");
        var heroToggleContainer2= document.querySelectorAll(".toggle-container2");
        var heroPricingLayout= document.querySelector(".pricing-layout");


        gsap.to(heroTableIntro, 0.5, {
          opacity: 1,
          x: 0,

        });
        gsap.to(heroToggleContainer, 0.5, {
          opacity: 1,
          x: 0,
        });
        gsap.to(heroToggleContainer2, 0.5, {
          opacity: 1,
          x: 0,
        });
        gsap.to(heroPricingLayout, 0.5, {
          y: 0,
          opacity: 1,
        });

//
var dofferoPriceTable = document.querySelector(".doffero-price-table");
var supportHead = document.querySelector(".support__head");
var faqItem = document.querySelectorAll(".faqs .faqs__item");
var compareFeaturesButton= document.querySelector("#compare-features-button");
if(compareFeaturesButton){
compareFeaturesButton.addEventListener('click', () => {  
gsap.to(window, {
  duration: 1,
  scrollTo:"#doffero-price-table-compare"
});
});}
        gsap.to(supportHead, 0.5, {
          opacity: 1,
          x: 0,
          scrollTrigger: {
              trigger: dofferoPriceTable,
              start: "bottom 40%"
          }
        });
        gsap.to(faqItem, 1, {
          y: 0,
          opacity: 1,
          stagger: 0.25,
          scrollTrigger: {
            trigger: supportHead,
            start: "bottom 45%"
          }
        });
       
        /* testimonials */
        var testiSection = document.querySelector(".block--testimonails");
        var testiTopTitle = document.querySelector(".block--testimonails .block-header__text");
        var testRating = document.querySelector(".block--testimonails .rating");
        var testiTitle = document.querySelector(".block--testimonails .block-header__title");
        var testiBoxes = document.querySelectorAll(".block--testimonails .testimonials__box");

        gsap.to(testiTopTitle, 0.5, {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: testiSection,
            start: "top 30%"
          }
        });
        gsap.to(testiTitle, 0.5, {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: testiSection,
            start: "top 30%"
          }
        });
        gsap.to(testRating, 0.5, {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: testiSection,
            start: "top 30%"
          }
        });
        gsap.to(testiBoxes, 1, {
          y: 0,
          opacity: 1,
          stagger: 0.25,
          scrollTrigger: {
            trigger: testiSection,
            start: "top 45%"
          }
        });

        /* customized-offer */
        var customizedOfferSection = document.querySelector(".block_customized_offer");
       var supportSection= document.querySelector(".faqs");
        gsap.to(customizedOfferSection, 0.5, {
          x: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: supportSection,
            start: "top 50%"
          }
        });


        /*block--price-table-compare */
        var priceTableCompareSection = document.querySelector(".block--price-table-compare");
        var priceTableCompareTitle = document.querySelector(".cennik_text_title");
        var priceTableCompareContent = document.querySelector(".pricing-table-compare");
        var priceTableHeade = document.querySelector("#table-header");
        var topHeader = document.querySelector(".top_header");

        gsap.to(priceTableCompareTitle, 0.5, {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: customizedOfferSection,
            start: "bottom 80%"
          }
        });
        gsap.to(priceTableCompareContent, 0.5, {
          x: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: priceTableCompareTitle,
            start: "top 90%"
          }
        });

        initTableSettings();

        function initTableSettings() {
          const dofferoHeader = window.innerWidth > 1000 ? document.getElementById('doffero_header') : document.getElementById('doffero_header_mobile');
          const tableHeader = document.getElementById("table-header-row");
          const pricingTable = document.getElementById("pricing-table");

          if (!dofferoHeader || !tableHeader || !pricingTable) return;

          const badgeHeight = 18;
          const headerTopPosition = 18;
          const headerOffset = dofferoHeader.offsetHeight + headerTopPosition + (badgeHeight/2)

          const tableHeaderOffset = tableHeader.offsetHeight
          const tableHeight = pricingTable.offsetHeight

          gsap.to("#table-header-row", {
            y: tableHeight - tableHeaderOffset,
            ease: "none",
            scrollTrigger: {
              trigger: "#pricing-table",
              start: `top ${headerOffset}`, 
              end: `bottom-=${headerOffset} ${tableHeaderOffset}`,
              scrub: true,               }
          });
        }

        /* supports */
        var pageBottomSection = document.querySelector(".page-bottom");
        var supportTopTitle = document.querySelector(".page-bottom .support__subtitle");
        var supportTitle = document.querySelector(".page-bottom  .support__title");
        var supportBtns = document.querySelectorAll(".page-bottom .support__btns");
        var faqsItems = document.querySelectorAll(".page-bottom .faqs__item");
        gsap.to(supportTopTitle, 0.5, {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: pageBottomSection,
            start: "top 50%"
          }
        });
        gsap.to(supportTitle, 0.5, {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: pageBottomSection,
            start: "top 50%"
          }
        });
        gsap.to(supportBtns, 0.5, {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: pageBottomSection,
            start: "top 40%"
          }
        });
        gsap.to(faqsItems, 1, {
          y: 0,
          opacity: 1,
          stagger: 0.25,
          scrollTrigger: {
            trigger: pageBottomSection,
            start: "top 40%"
          }
        });
      };
      this.events = function () {
        // offer page - faq dropdown
        $(".faqs").on("click", ".item-bar", function () {
          $(this).parents(".faqs__item").toggleClass("is-opened");
          $(this).next(".item-dropbox").slideToggle({
            complete: function () {
              ScrollTrigger.refresh();
            }
          });
        });
  
        /**
         * Swticher
         */
        $(".custom-switch").on("click", function () {
          $(this).toggleClass("is-dark");
          var switchButton = $(".custom-switch").find(".custom-switch__button");
          var switchWrapperWidth = parseInt($(this).width());
          var switchButtonWidth = parseInt(switchButton.width());
          var movingPixels = switchWrapperWidth - switchButtonWidth;
          $(".custom-switch-text").find("span").removeClass("active");
          if ($(this).hasClass("is-dark")) {
            $(".custom-switch-text").find(".moon").addClass("active");
            $(".showcase-screen").find(".dark").addClass("showed");
            switchButton.animate({
              left: "+=" + (movingPixels - 4)
            }, 250, "easeInOutQuint");
          } else {
            $(".custom-switch-text").find(".sun").addClass("active");
            $(".showcase-screen").find(".dark").removeClass("showed");
            switchButton.animate({
              left: "-=" + (movingPixels - 4)
            }, 250, "easeInOutQuint");
          }
        });
  
        /* Slide menu */
        $(".slide-menu--overlay").on("click", function () {
          $(".slide-menu").removeClass("is-opened");
          $(".slide-menu--overlay").hide();
        });
        $(".js-open-menu").on("click", function () {
          $(".slide-menu--overlay").show();
          $(".slide-menu").addClass("is-opened");
        });
        $(".js-close-menu").on("click", function () {
          $(".slide-menu--overlay").hide();
          $(".slide-menu").removeClass("is-opened");
        });
  
        // $(".chat-btn").on("click", function() {
        //     window.chaport.on('ready', function () {
        //         window.chaport.open();
        //     })
        // });
      };
    }
})();
